module.exports = __webpack_public_path__ + "assets/img/cq.017b18f6.jpg";